import { render, staticRenderFns } from "./product-group-modal.vue?vue&type=template&id=509be322&"
import script from "./product-group-modal.vue?vue&type=script&lang=js&"
export * from "./product-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports